import * as React from 'react';

import * as SwitchPrimitives from '@radix-ui/react-switch';

import { cn } from '@/utils';

const Switch = React.forwardRef(({ className, small, ...props }, ref) => (
	<SwitchPrimitives.Root
		className={cn(
			'group relative inline-flex shrink-0 cursor-pointer items-center transition-colors disabled:cursor-not-allowed disabled:opacity-50',
			small ? 'h-4' : 'h-5',
			className
		)}
		{...props}
		ref={ref}
	>
		<div
			className={cn(
				'h-5 rounded-full group-data-[state=checked]:bg-[#DB593B] group-data-[state=unchecked]:bg-gray-500',
				small ? 'w-8' : 'w-10'
			)}
		/>
		<SwitchPrimitives.Thumb
			className={cn(
				'pointer-events-none absolute left-0 block rounded-full border-2 border-gray-200 bg-background shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0',
				small
					? 'h-3 w-3 data-[state=checked]:translate-x-3'
					: 'h-4 w-4 data-[state=checked]:translate-x-[22px]'
			)}
		/>
	</SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export default Switch;
